import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
// API
import { getMdUsage } from '../../../api/mdProfileApi';
// Context
import { useMdProfileContext } from '../context/useMdProfileContext';
import moment from 'moment';

export default function MDUsage() {
  const { viewProfile } = useContext(useMdProfileContext);

  const [productList, setProductList] = useState({ loading: false, items: [] });

  const columns = [
    {
      field: 'rank',
      headerName: 'Rank',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'product_name',
      headerName: 'Product',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'contribution',
      headerName: 'Share %',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => `${parseFloat(row.contribution).toFixed(2)}%`,
    },
  ];

  const loadMdUsageList = async () => {
    setProductList({ ...productList, loading: true });
    const request = {
      doctor_id: viewProfile?.doctor_id,
      year: moment().format('YYYY'),
    };

    const response = await getMdUsage(request);
    const { code, data } = response.data;

    if (code === '00003') {
      setProductList({ ...productList, loading: false, items: data });
    }
  };

  const renderDataGrid = (data) => {
    return (
      <Box
        className='table-container'
        sx={{
          height: `800px`,
          '& .super-app-theme--header': {
            fontWeight: 'bold',
            backgroundColor: '#6B8D3E',
            color: '#fff',
          },
        }}
      >
        <DataGridPro
          loading={productList?.loading}
          rows={data}
          columns={columns}
          initialState={{
            ...data?.initialState,
            pagination: {
              pageSize: 50,
            },
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          getRowClassName={(params) => {
            return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
          }}
        />
      </Box>
    );
  };
  useEffect(() => {
    loadMdUsageList();
  }, [viewProfile]);

  return (
    <Grid container spacing={2} mt={2}>
      <Grid item sm={12} md={12} lg={4} xl={4}>
        <Typography sx={{ fontWeight: 'bold' }} variant='h6' gutterBottom>
          TOP 15 Products
        </Typography>
        {renderDataGrid(productList?.items?.slice(0, 15))}
      </Grid>
      <Grid item sm={12} md={12} lg={4} xl={4}>
        <Typography sx={{ fontWeight: 'bold' }} variant='h6' gutterBottom>
          MID 20 Products
        </Typography>
        {renderDataGrid(productList?.items?.slice(15, 35))}
      </Grid>
      <Grid item sm={12} md={12} lg={4} xl={4}>
        <Typography sx={{ fontWeight: 'bold' }} variant='h6' gutterBottom>
          BOTTOM Products
        </Typography>
        {renderDataGrid(productList?.items?.slice(35))}
      </Grid>
    </Grid>
  );
}
